import type { CustomFilterMainCreators } from '@/app/common/filters/surfaces/forms/FilterGroupsComponents.tsx';
import React, { useRef } from 'react';
import type { HandleFilterChanged } from '@/app/common/filters/core/filterComponentType.ts';
import { StickyFirstPill } from '@/app/common/filters/surfaces/bar/StickyFirstPill.tsx';
import type { FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import { SwipeLayoutContainer } from '@/app/common/filters/surfaces/bar/SwipeLayout/styled.ts';
import { FILTERS_HEIGHT } from '@/app/common/constants.ts';

export type SwipeLayoutProps = {
  filterPills: FilterPill[];
  customFilterMainCreators: CustomFilterMainCreators;
  isLoading: boolean;
  handleFilterChanged: HandleFilterChanged;
  // Only the evo bar moves an applied pill to the front, so only it has a reason to scroll back.
  scrollToStartOnChange?: boolean;
};

const SwipeLayout = ({
  filterPills,
  customFilterMainCreators,
  isLoading,
  handleFilterChanged,
  scrollToStartOnChange,
}: SwipeLayoutProps) => {
  const barRef = useRef<HTMLDivElement>(null);

  const handleFilterChangedAtStart: HandleFilterChanged = (...args) => {
    if (scrollToStartOnChange) barRef.current?.scroll({ left: 0, behavior: 'instant' });
    handleFilterChanged(...args);
  };

  return (
    <SwipeLayoutContainer
      ref={barRef}
      style={{ height: FILTERS_HEIGHT }}
      className="horizontal-filters-container"
      aria-busy={isLoading}
    >
      <StickyFirstPill
        filterPills={filterPills}
        customFilterMainCreators={customFilterMainCreators}
        isLoading={isLoading}
        handleFilterChanged={handleFilterChangedAtStart}
        useModal={true}
      />
    </SwipeLayoutContainer>
  );
};

export default SwipeLayout;
